import { AbstractEntityService } from "./AbstractEntityService";
import { restService } from "./RestService";

export class RoomService extends AbstractEntityService {
    constructor(baseUrl) {
        super();
        this.baseUrl = baseUrl;
    }

    // GET /api/properties/{propertyId}/rooms
    async findAll(propertyId) {
        const url = `${this.baseUrl}/properties/${propertyId}/rooms`;
        try {
            return await super.find(url);
        } catch (error) {
            this.handleError(error, `Unable to load rooms - please see server logs for more details`);
        }
    }

    // GET /api/properties/{propertyId}/rooms/{id}
    async findById(propertyId, id) {
        const url = `${this.baseUrl}/properties/${propertyId}/rooms/${id}`;
        try {
            return await super.find(url);
        } catch (error) {
            this.handleError(error, "Unable to find Room - please see server logs for more details");
        }
    }

    // POST /api/properties/{propertyId}/rooms
    async create(propertyId, room) {
        const url = `${this.baseUrl}/properties/${propertyId}/rooms`;
        try {
            return await super.create(url, room);
        } catch (error) {
            this.handleError(error, `Unable to create room - please see server logs for more details`);
        }
    }

    // PUT /api/properties/{propertyId}/rooms/{id}
    async update(propertyId, room) {
        const url = `${this.baseUrl}/properties/${propertyId}/rooms/${room.id}`;
        try {
            return await super.update(url, room);
        } catch (error) {
            this.handleError(error, `Unable to update room - please see server logs for more details`);
        }
    }

    // DELETE /api/properties/{propertyId}/rooms/{id}
    async delete(propertyId, roomId) {
        const url = `${this.baseUrl}/properties/${propertyId}/rooms/${roomId}`;
        try {
            return await super.delete(url);
        } catch (error) {
            this.handleError(error, `Unable to delete room - please see server logs for more details`);
        }
    }

    // GET /api/properties/{propertyId}/rooms/{id}/pictures  →  returns PicturesAlbum
    async getPictures(propertyId, roomId) {
        const url = `${this.baseUrl}/properties/${propertyId}/rooms/${roomId}/pictures`;
        try {
            return await super.find(url);
        } catch (error) {
            this.handleError(error, `Unable to load room pictures - please see server logs for more details`);
        }
    }

    // POST /api/properties/{propertyId}/rooms/{id}/pictures (multipart)  →  returns PicturesAlbum
    async uploadPictures(propertyId, roomId, files) {
        const url = `${this.baseUrl}/properties/${propertyId}/rooms/${roomId}/pictures`;
        const formData = new FormData();
        files.forEach(file => formData.append('files', file));
        try {
            return await restService.post(url, formData, { 'Content-Type': 'multipart/form-data' });
        } catch (error) {
            this.handleError(error, 'Unable to upload room pictures - please see server logs for more details');
        }
    }

    // DELETE /api/properties/{propertyId}/rooms/{id}/pictures  →  returns PicturesAlbum
    async deletePictures(propertyId, roomId, fileNames) {
        const url = `${this.baseUrl}/properties/${propertyId}/rooms/${roomId}/pictures`;
        try {
            return await restService.delete(url, fileNames);
        } catch (error) {
            this.handleError(error, `Unable to delete room pictures - please see server logs for more details`);
        }
    }

    // PUT /api/properties/{propertyId}/rooms/{id}/pictures/reorder  →  returns PicturesAlbum
    async reorderPictures(propertyId, roomId, fileNamesInOrder) {
        const url = `${this.baseUrl}/properties/${propertyId}/rooms/${roomId}/pictures/reorder`;
        try {
            return await restService.put(url, fileNamesInOrder);
        } catch (error) {
            this.handleError(error, `Unable to reorder room pictures - please see server logs for more details`);
        }
    }
}
